import type { ReactNode } from 'react';

/**
 * Inline form error — the single place the destructive color + `rise-in` entrance live, so every
 * auth surface (fields, sign-in, create-account, 2FA, password reset) reads and animates the same.
 * Keyed on the message so a changed error re-triggers the animation. Size / margin / alignment are
 * contextual, so pass them via `className` (e.g. `text-sm` for field errors, `text-base` for a
 * form-level error, `text-center` under the centered 2FA step).
 */
export function InlineError({ children, className = '' }: { children?: ReactNode; className?: string }) {
  if (!children) return null;
  return (
    <p key={String(children)} className={`text-destructive rise-in ${className}`.trim()}>
      {children}
    </p>
  );
}

export default InlineError;
